import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from "@heroui/modal";
import { Image } from "@heroui/image";
import { cn } from "@heroui/theme";
import { Icon } from "@iconify/react";

import { ViewImageProps } from "@/types";

const ViewImage = ({ img, className }: ViewImageProps) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      <div className="relative group cursor-pointer  ">
        <button
          className={
            "absolute lg:h-full lg:w-full lg:inset-0 bottom-0 right-0   flex items-center justify-center z-20 lg:opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out"
          }
          onClick={onOpen}
        >
          <div className="rounded-full p-2 bg-black/80">
            <Icon
              className="text-white lg:text-4xl text-xl"
              icon="ri:zoom-in-fill"
            />
          </div>
        </button>
        <Image
          disableAnimation
          disableSkeleton
          alt="cover image"
          className={cn(
            "transition-transform duration-300 ease-in-out w-full h-full object-top group-hover:scale-105",
            className,
          )}
          src={img}
        />
      </div>

      <Modal
        className="bg-transparent shadow-none"
        classNames={{
          closeButton:
            "  font-bold text-foreground transition-all duration-300 ease-in-out bg-background",
        }}
        isOpen={isOpen}
        placement="center"
        size="5xl"
        onOpenChange={onOpenChange}
      >
        <ModalContent className="rounded-none animate__animated animate__zoomIn animate__faster">
          {() => (
            <>
              <ModalHeader className="bg-transparent text-white mb-4 " />
              <ModalBody className=" ">
                <Image
                  disableAnimation
                  disableSkeleton
                  alt="image"
                  className=" object-contain h-screen-80"
                  radius="none"
                  src={img}
                />
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ViewImage;
